import { withHandlers } from 'recompose'

export default withHandlers({
  handleAddNewVehicle: ({ toggleHandlers, initiateAddNewVehicle }) => () => {
    toggleHandlers.onClick()
    initiateAddNewVehicle()
  }
})
